

/**
  * @description The function to login to Ink Finder
  * @param {unknown} AlertMessages Unknown
  */
function AlertMessagesController(
  AlertMessages
  ) {
  let vm = this;
  vm.closeAlert = closeAlert;

/**
  * @description
  * Alerts system
  * @param {array} alert The alert message object
  */
  vm.alerts = AlertMessages.list;

/**
  * @name closeAlert
  * @description Function to close the alert from the view
  * @param {number} index The index of the alerts array to close
  */
  function closeAlert(index) {
    AlertMessages.close(index);
  }
}

angular
  .module('inkfinder')
  .controller('AlertMessagesController', AlertMessagesController);



// WEBPACK FOOTER //
// ./components/alerts/alert-messages.controller.js